import { reactive, readonly, ref } from 'vue';

interface UseStateOptions<T> {
  default: T
}

export default function useGlobalState<T>(options: UseStateOptions<T>) {
  const state = ref(options.default);
  return {
    state,
    mutate: (value: T) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      state.value = value;
    },
  };
}
